import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-loader-fullscreen',
  templateUrl: './loader-fullscreen.component.html',
  styleUrls: ['./loader-fullscreen.component.scss']
})
export class LoaderFullscreenComponent {
  @Input() isFullScreen: boolean;
}
